import { setCompHeightCSSVar } from '../../utils';
export default function create(options, dom) {
  if (dom) {
    setCompHeightCSSVar(dom);
  }
  return [{
    ...options,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 100
      }
    },
    keyframes: [{
      transform: 'translateY(-100vh)'
    }, {
      transform: 'translateY(var(--motion-comp-height, 100%))'
    }]
  }];
}
//# sourceMappingURL=BgReveal.js.map